import { FETCH_PROOFS_SUCCESS } from 'constants/payment';
import { DELETE_PROOF_FILE_SUCCESS } from 'constants/proofs';
import omit from 'lodash/omit';
import type { ProofFile } from 'models/proofFile';

type ProofFilesAction =
  | {
      type: typeof FETCH_PROOFS_SUCCESS;
      payload: {
        entities: {
          proofFiles: Record<string, ProofFile>;
        };
      };
    }
  | {
      type: typeof DELETE_PROOF_FILE_SUCCESS;
      payload: {
        fileId: string;
      };
    };

const proofFiles = (
  state: Record<string, ProofFile> = {},
  action: ProofFilesAction,
) => {
  switch (action.type) {
    case FETCH_PROOFS_SUCCESS:
      const {
        entities: { proofFiles },
      } = action.payload;

      return { ...state, ...proofFiles };
    case DELETE_PROOF_FILE_SUCCESS:
      const { fileId } = action.payload;
      const newFiles = omit(state, [fileId]);

      return { ...newFiles };
    default:
      return state;
  }
};

export { proofFiles };
